import React, { Component, Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import {ROUTES} from '../routes';
import LoginHeader from './common/LoginHeader';
import Footer from './common/Footer';
import LoginForm from './common/LoginForm';

class Login extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: props.user,
      status: props.status
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.compName == 'Auth' && nextProps.status != this.state.status){
      this.setState({
        user: nextProps.user,
        status: nextProps.status
      });
    }
  }
  
  render() {
    const {user} = this.state;

    if(typeof user.token !== 'undefined' && user.token !== null){
      return <Redirect to='/transactions'/>
    }

    return (
      <section className="main-bg onboarding-screeens">
        <LoginHeader />
        <div className='onboard-form-wrpr'>
          <div className="container">
            <div className="d-flex align-center justify-center">
              <LoginForm />
            </div>
          </div>
        </div>
        
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: {...state.Auth.user},
    status: state.Auth.status,
    compName: state.Auth.compName
  };
}

export default connect(mapStateToProps)(Login);